const EDITABLE_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

export function isTypingInEditableField(element = document.activeElement) {
  if (!element || !(element instanceof Element)) {
    return false;
  }

  if (EDITABLE_TAGS.has(element.tagName)) {
    return true;
  }

  if (element.tagName === 'IFRAME') {
    return true;
  }

  if (element.isContentEditable) {
    return true;
  }

  if (element.closest('[contenteditable="true"]')) {
    return true;
  }

  if (element.getAttribute('role') === 'textbox') {
    return true;
  }

  return false;
}
